import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Fonts are bundled with the site (open licence), never loaded from Google's servers.
import '@fontsource-variable/archivo/wdth.css';
import '@fontsource/atkinson-hyperlegible-next/latin-400.css';
import '@fontsource/atkinson-hyperlegible-next/latin-700.css';
import '@fontsource/space-mono/latin-400.css';
// One font per era, only used for year numbers. Browsers download a file only when it is shown.
import '@fontsource/comic-neue/latin-700.css';
import '@fontsource/orbitron/latin-800.css';
import '@fontsource/fredoka/latin-700.css';
import '@fontsource/nunito/latin-800.css';
import '@fontsource/lobster/latin-400.css';
import '@fontsource/raleway/latin-200.css';
import '@fontsource/raleway/latin-700.css';
import '@fontsource/montserrat/latin-900.css';
import '@fontsource/fraunces/latin-700.css';
import '@fontsource/bagel-fat-one/latin-400.css';
import '@fontsource/gloock/latin-400.css';
import '@fontsource/arimo/latin-400.css';
import './styles/palette.css';
import './styles/app.css';
import App from './App';

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
